import { render } from "./FosoftechBrand-2.vue?vue&type=template&id=27fda072&scoped=true"
import script from "./FosoftechBrand-2.vue?vue&type=script&lang=js"
export * from "./FosoftechBrand-2.vue?vue&type=script&lang=js"

import "./FosoftechBrand-2.vue?vue&type=style&index=0&id=27fda072&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fda072"]])

export default __exports__